function About() {
  return (
    <div className="container">
      <h1 className='text-6xl mb-4'>Github App</h1>
      <p className='mb-4 text-2xl font-light'>
        A React app to search GitHub profiles and see profile details. 
      </p>
      <p className="mb-4 font-light">Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam similique quidem incidunt unde aperiam magni voluptatum pariatur, sint repudiandae, obcaecati itaque possimus inventore illum quae enim porro! Distinctio harum odio ducimus, corrupti voluptas ullam laudantium corporis aspernatur saepe nobis id aliquid mollitia eveniet officiis assumenda obcaecati tempore ex voluptatem praesentium.</p>
      <p className='text-lg text-gray-400'>
        Version <span className='text-white'>1.2.0</span>
      </p>
      
    </div>
  )
}

export default About
